<template>
    <div id="statistics">
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-6 mt-lg-17">
                        <div class="section-heading heading-light-left">
                            <span class="subtitle primary">Estadísticas.</span>
                            <h2 class="title text-dark font-weight-100">La Red en <span class="bold">números.</span></h2>
                            <!-- <button @click.stop="goToPage('yieldPage')" class="rg-know-more axil-btn btn-borderd btn-fluid btn-primary rg-style-button w-25 p-4"
                                name="submit-btn">Conoce más</button> -->
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <div class="row">
                            <div class="col-lg-6 col-6" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                                <div class="counterup-progress active">
                                    <div class="icon">
                                        <div class="net-yield set-img" alt="Promedio anual"></div>
                                    </div>
                                    <div class="count-number h2 bold">
                                        <span v-if="isMounted" class="number count" :data-count="parseFloat((rgStats.net_yield || 0), 1)">{{ parseFloat((rgStats.net_yield || 0), 1) }} </span>
                                        <span class="symbol"> %*</span>
                                    </div>
                                    <h6 class="title">Retorno promedio anual  <router-link :to="{ name: 'yieldPage' }">Conoce más</router-link>.</h6>
                                </div>
                            </div>
                            <div class="col-lg-6 col-6 mt--80" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                                <div class="counterup-progress">
                                    <div class="icon">
                                        <div class="aum set-img" alt="AUM"></div>
                                    </div>
                                    <div class="count-number h2 bold">
                                        <span class="symbol">$</span>
                                        <span v-if="isMounted" class="number count" :data-count="parseMillions(rgStats.total_aum || 0)">{{  parseMillions(rgStats.amount_paid_to_investors || 0) }}</span>
                                        <span class="symbol"> M</span>
                                    </div>
                                    <h6 class="title">Bajo gestión</h6>
                                </div>
                            </div>
                            <div class="col-lg-6 col-6 align-cards" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                                <div class="counterup-progress">
                                    <div class="icon">
                                        <div class="users set-img" alt="inversionistas"></div>
                                    </div>
                                    <div class="count-number h2">
                                        <span class="symbol">+</span>
                                        <span v-if="isMounted" class="number count" :data-count="(rgStats.effective_investors || 0)">{{ format_price(rgStats.effective_investors || 0,0) }}</span>
                                    </div>
                                    <h6 class="title">Inversionistas que confían en nosotros</h6>
                                </div>
                            </div>
                            <div class="col-lg-6 col-6" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                                <div class="counterup-progress">
                                    <div class="icon">
                                        <div class="projects set-img" alt="proyectos exitosos"></div>
                                    </div>
                                    <div class="count-number h2">
                                        <span class="symbol">+</span>
                                        <span v-if="isMounted" class="number count" :data-count="(rgStats.accumulated_successful_projects || 0)">{{ format_price(rgStats.accumulated_successful_projects || 0,0) }}</span>
                                    </div>
                                    <h6 class="title">Proyectos fondeados</h6>
                                </div>
                            </div>
                            <div class="col-lg-6 col-6 align-cards" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100">
                                <div class="counterup-progress">
                                    <div class="icon">
                                        <div class="sun set-img" alt="proyectos exitosos"></div>
                                    </div>
                                    <div class="count-number h2">
                                        <span class="symbol">+</span>
                                        <span v-if="isMounted" class="number count" :data-count="(rgStats.accumulated_environmental_impact || 0)">{{ format_price(getOds.toneladas.toFixed(0) || 0) }}</span>
                                    </div>
                                    <h6 class="title">TonCO<sub>2</sub> evitadas (directas)</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
export default {
    name: "Statistics",
    props: ["rgStats", "isMounted", "odsStats"],
    mixins: [formatHelper],
    components: {
    },
    data() {
        return {
            icon_base: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-"
        }
    },
    computed: {
        getOds() {
            return JSON.parse(this.odsStats);
        }
    }
}

</script>

<style scoped>

.counterup-progress {
    border-color: var(--color-primary);
    border: solid;
    color: var(--color-primary);
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
    min-height: 19.8rem !important;
}

    .counterup-progress.active {
        background: var(--color-primary) !important;
    }
    .counterup-progress:hover, .counterup-progress:hover {
        background: var(--color-primary) !important;
    }
    .counterup-progress:hover, .counterup-progress:hover span {
        color: var(--color-white);
    }
    .counterup-progress.active span {
        color: var(--color-white);
    }
    .counterup-progress.active .net-yield{
        background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-yield-black.png") !important;
    }
    .counterup-progress:hover .aum{
        background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-db-black.png") !important;
    }
    .counterup-progress:hover .users{
        background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-users-black.png") !important;
    }
    .counterup-progress:hover .projects{
        background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-home-black.png") !important;
    }
    .counterup-progress:hover .sun{
        background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-sun-black.png") !important;
    }

    
.set-img {
    height: 2.6rem;
    background-repeat: no-repeat;
    background-position: top;
    background-size: 15%;
}

.net-yield {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-yield-green.png");
}
.aum{
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-db-green.png");
    background-size: 13%;
}
.users{
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-users-green.png");
}
.projects{
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-home-green.png");
}
.sun{
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-sun-green.png");
}

.counterup-progress h6{
    color: var(--color-dark);
}

.align-cards {
    position: relative;
    top: -5rem;
}

.counterup-progress span{
    top: -3px;
    margin-left: 5px;
    margin-right: 5px;
}


</style>